import { useRef } from 'react';

const trimString = (str) => (typeof str !== 'string') ? '' : str.trim();

const useExistingContacts = (list = [], opts) => {
    // console.log(opts);
    const { CAPI, i18n, showFlashMessage } = opts;
    const contactsRef = useRef({
        emailsList: list,
        existingContacts: undefined,
    });

    const create = (eml, params) => {
        const { onSuccess, onFailure } = params;
        const trimName = trimString(eml.personal);
        const name = (trimName.length > 0) && (trimName !== eml.address)
            ? trimName
            : eml.address;

        CAPI.createContact(
            name, [eml.address], 'webmail',
            () => {
                const text = i18n.addNewSuccess.replace('%s', name);
                update(eml.address, true);
                showFlashMessage('success', text);
                onSuccess();
            },
            () => {
                showFlashMessage('danger', i18n.addNewFail);
                onFailure();
            }
        );
    };

    const check = (eml, callback) => {
        const { existingContacts } = contactsRef.current;
        if (existingContacts) {
            callback(existingContacts[eml]);
            return;
        }
        const { current } = contactsRef;

        let emailListToCheck = [];
        for (let i = 0; i < current.emailsList.length; i++) {
            emailListToCheck[i] = current.emailsList[i].toLowerCase();
        }

        CAPI.getExistingContacts(
            emailListToCheck,
            (data) => {
                contactsRef.current = {
                    ...current,
                    existingContacts: data
                };
                callback(data[eml]);
            }
        );
    };

    const update = (eml, val = true) => {
        const { current } = contactsRef;
        contactsRef.current = {
            ...current,
            existingContacts: {
                ...current.existingContacts,
                [eml]: val,
            }
        };
        // console.log('Result:', contactsRef.current);
    };

    return { create, check, update };
};

export default useExistingContacts;
